<template>
  <div class="animated fadeIn faster">
    <div
      v-show="showNav"
      class="row py-2 bg-darker justify-content-between show-class"
    >
      <div class="ml-2 ml-md-4 align-self-center">
        <span>
          {{ searchItems.length }} Models
          <!--&& selectedFilters.searchTerm.length == 0 && selectedFilters.brand.length != 1 -->
          <span>of {{ items.length }}</span> Available
        </span>
        <!-- Do - 1 because aspire filter is always applied -->
        <span class="text-small" v-if="filtersCount > 2"
          >- {{ filtersCount - 1 }} filters applied</span
        >
      </div>
      <div class="mr-2 mr-md-4 align-self-center">
        <router-link to="/favorites" class="ml-1">
          <i class="fas fa-2x fa-heart text-primary"></i>
        </router-link>
        <a @click="$emit('toggleFilter')" class="text-primary ml-1">
          <i class="fas fa-2x text-primary fa-filter"></i>
        </a>
        <a
          v-if="!isGridView"
          @click="isGridView = true"
          class="text-primary ml-1"
        >
          <i class="fas fa-2x text-primary fa-arrow-circle-left"></i>
        </a>
      </div>
    </div>
    <div class="favorite-message bg-primary" id="fav-msg">
      <h3>
        <i class="fa fa-thumbs-up" aria-hidden="true"></i> Added to Favorites!
      </h3>
    </div>

    <div class="row mt-4" v-if="searchItems.length === 0">
      <div class="col text-center">
        <div
          v-if="loading"
          class="spinner-border"
          style="width: 3rem; height: 3rem;"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <h2 v-else>No items found, please expand your search.</h2>
      </div>
    </div>

    <div v-if="isGridView" class="row px-3 mt-3">
      <div
        v-for="(item, index) in searchItems"
        :key="item.id"
        :class="[
          searchItems[index].id.split('-')[0] == 'brand'
            ? 'row bg-white my-2 w-100 p-2 mx-auto'
            : 'col-6 col-sm-4 col-md-3 p-2'
        ]"
      >
        <div v-if="searchItems[index].id.split('-')[0] == 'brand'"></div>
        <div class="card shadowed h-100" v-else>
          <div class="card-body p-2">
            <p class="mb-1 small">
              {{ item.model }}
              <span
                v-if="checkFavoriteForOne(item.id)"
                class="float-right addFav no-bg-button"
              >
                <i class="fa text-primary fa-heart" aria-hidden="true"></i>
              </span>
              <span v-else class="no-bg-button float-right">
                <i
                  class="far fa-heart"
                  aria-hidden="true"
                  @click="$emit('addFavorite', item)"
                ></i>
              </span>
            </p>
            <img
              @click="
                modelIndex = index;
                isGridView = false;
              "
              class="w-100 mx-auto"
              :src="S3URL + '200/' + basename(item.imagePicked)"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="carousel animated faster fadeIn slide my-3"
      data-ride="carousel"
      id="carousel"
      data-interval="false"
      data-touch="false"
    >
      <div class="carousel-inner slides">
        <div
          class="carousel-item"
          v-for="(item, index) in searchItems"
          :key="item.id"
          :class="{ active: index === modelIndex }"
        >
          <div class="inner-item">
            <div class="row">
              <div class="col-12">
                <h3 class="title text-center">{{ item.model }}</h3>
                <hr class="my-1" />
              </div>
              <div class="col-sm-7 product-image">
                <img
                  @click="
                    $emit('showImage', {
                      imageSelected: S3URL + item.imagePicked,
                      measurement: item.measure,
                      variants: item.variants
                    })
                  "
                  class="img-fluid"
                  :src="S3URL + item.imagePicked"
                  data-toggle="modal"
                  data-target="#zoomImageModal"
                />
              </div>
              <div class="col-sm-5 text-left">
                <div class="mt-1 text-center">
                  <p>
                    <b>FEATURES:</b>
                    <br />
                    <span v-html="item.features"></span>
                  </p>
                  <div class="table-responsive hidden-sm">
                    <table class="table mb-1 table-sm">
                      <thead>
                        <tr>
                          <th>eye</th>
                          <th>a</th>
                          <th>b</th>
                          <th>ed</th>
                          <th>dbl</th>
                          <th>temples</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, key) in item.measure" :key="key">
                          <td v-for="(col, index) in row" :key="index">
                            {{ col }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <hr class="d-none d-sm-block my-1" />
            <div
              class="row mx-auto justify-content-center justify-content-md-around align-items-center"
            >
              <div class="col-12 col-sm-auto">
                <form class="justify-content-center form-inline">
                  <label class="mr-2">
                    <b>COLORS:</b>
                  </label>
                  <select
                    class="form-control my-1 mr-sm-2"
                    v-model="item.imagePicked"
                  >
                    <option
                      v-for="varcol in item.variants"
                      :value="varcol.src"
                      :selected="item.isPrimary"
                      :key="varcol.color"
                      >{{ varcol.color }}</option
                    >
                  </select>
                </form>
              </div>
              <div class="col-12 col-sm-auto">
                <div class="row justify-content-center align-items-center my-2">
                  <button
                    class="show-sm-inline btn btn-info btn-sm mr-2"
                    @click="showMeasurements(item.measure)"
                    data-toggle="modal"
                    data-target="#zoomImageModal"
                  >
                    <i class="fas fa-info"></i>
                  </button>
                  <b>SIZES:</b>
                  <span
                    class="btn btn-sm rounded-circle border border-info ml-2"
                    v-for="size in item.sizes"
                    :key="size"
                    :class="[size===item.sizePicked ? 'btn-info' : 'btn-default']"
                  >
                    <input
                      class="d-none"
                      type="radio"
                      :value="size"
                      :id="index + '-' + size"
                      v-model="item.sizePicked"
                    />
                    <label class="mb-0" :for="index + '-' + size">
                      {{ size.substring(0, 2) }}
                    </label>
                  </span>
                </div>
              </div>
              <div class="col-12 col-sm-auto">
                <div class="row justify-content-center">
                  <button
                    class="mx-1 btn btn-primary btn-sm btn-xs-block my-1"
                    @click="$emit('addFavorite', item)"
                  >
                    <i class="fa fa-heart" aria-hidden="true"></i> Add to
                    favorites
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carousel"
          role="button"
          data-slide="prev"
        >
          <span class="big-font">
            <i class="text-dark fas fa-chevron-left"></i>
          </span>
        </a>
        <a
          class="carousel-control-next"
          href="#carousel"
          role="button"
          data-slide="next"
        >
          <span class="big-font">
            <i class="text-dark fas fa-chevron-right"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  props: {
    favList: { type: Array, default: () => [] },
    S3URL: { type: String, default: "" },
    searchItems: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    filtersCount: { type: Number, default: 0 },
    showNav: { type: Boolean, default: true }
  },
  data: function() {
    return {
      isGridView: true,
      modelIndex: 0
    };
  },
  methods: {
    checkFavoriteForOne(itemId) {
      // check if in favorites for one item. Used to fill the heart badges on the grid view
      for (let favorite of this.favList)
        if (itemId == favorite.id.split("|")[0]) return true;
      return false;
    },
    basename(imgpath) {
      return imgpath.split("/").reverse()[0];
    },
    showMeasurements(measurement) {
      this.$emit("showImage", { measureSelected: measurement });
    }
  },
  computed: {
    loading: function() {
      return this.items.length === 0;
    }
  },
  watch: {
    filtersCount: function() {
      // findFirstModel. If filter changes, change the carousel active item to the first model
      for (let i = 0; i < this.searchItems.length; i++) {
        if (this.searchItems[i].model) {
          this.modelIndex = i;
          return;
        }
      }
      return (this.modelIndex = 0);
    },
    isGridView: {
      // only enable touchswipe on mobile. if we do it on desktop there is a bug w/ dropdown box
      handler(to) {
        //only enable on mobile
        if (!/Mobi|Android/i.test(navigator.userAgent)) {
          return;
        }
        if (!to) {
          $(document).ready(function() {
            $("#carousel").carousel();
            $("#carousel").swipe({
              swipeRight: function() {
                $(this).carousel("prev");
              },
              swipeLeft: function() {
                $(this).carousel("next");
              }
            });
            $("#carousel").swipe("enable");
          });
        } else {
          $("#carousel").swipe("disable");
        }
      }
    }
  }
};
</script>
